import React from "react";
import Modal from "./Modal";
import Button from "./Button";

const Question = ({ show, onClose, message, onConfirm }) => (
  <Modal
    open={!!show}
    onClose={onClose}
    title="Επιβεβαίωση"
    footer={
      <>
        <Button variant="secondary" onClick={onClose}>
          Ακύρωση
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Επιβεβαίωση
        </Button>
      </>
    }
  >
    <p className="py-2 text-slate-700">{message}</p>
  </Modal>
);

export default Question;
